import { API_BASE_URL } from '../config';
import api from './axiosInstance';
import qs from 'qs';

export async function getPagedCasesByUser(
  page = 1,
  pageSize = 10,
  search = null,
  sortBy = null,
  direction = 'desc'
) {
  try {
    const params = {
      page,
      pageSize,
      //userId: search.UserId,
      search: search.SearchLegalCases || '',
      role: search.Role || '',
      caseName: search.Case || '',
      client: search.Client || '',
      courts: search.Courts || [],
      sponsorIds: search.Lawyers || [],
      process: search.Process || [],
      stateIds: search.States || [],
      startDate: search.StartDate || null,
      endDate: search.EndDate || null,
      myCases: search.MyCases || 'mis causas',
      groups: search.Groups || [],
      sortBy: sortBy || null,
      desc: direction === 'desc' ? true : false,
      internalStateStatus:
        search.IsActive === null || search.IsActive === undefined
          ? undefined
          : search.IsActive
            ? 'Activa'
            : 'Inactiva',
    };

    // Solo agregar SearchLegalCases si tiene valor
    if (search && search?.SearchLegalCases && search?.SearchLegalCases.trim()) {
      params.search = search?.SearchLegalCases.trim();
    }

    const response = await api.get('CasesSaas/paged', {
      headers: {
        'Content-Type': 'application/json',
      },
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    return {
      page: response.data.page,
      pageSize: response.data.pageSize,
      total: response.data.total,
      activeCount: response.data.activeCount,
      pendingCount: response.data.pendingCount,
      closedCount: response.data.closedCount,
      cases: response.data.data || [],
    };
  } catch (error) {
    console.error('getPagedCasesByUser failed:', error);
    console.error('Error details:', error.response?.data);
    error.customMessage = 'No se pudo obtener el listado de causas.';
    throw error;
  }
}

export async function getCaseById(idCase) {
  try {
    const response = await api.post(`CasesSaas/GetCase/${idCase}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('getCaseById failed:', error);
    console.error('Error details:', error.response?.data);
    error.customMessage = 'No se pudo obtener la causa.';
    throw error;
  }
}

export async function createCase(data) {
  try {
    const response = await api.post('CasesSaas/Add', data, {
      headers: { 'Content-Type': 'application/json' },
    });

    return response.data;
  } catch (error) {
    console.error('createCase failed:', error);
    console.error('Error details:', error.response?.data);
    throw error;
  }
}

export async function updateCase(updatedCase) {
  try {
    const payload = {
      ...updatedCase,
      caseId: updatedCase.id,
    };

    const response = await api.put('CasesSaas/Update', payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    return response.data;
  } catch (error) {
    console.error('updateCase failed:', error);
    console.error('Error details:', error.response?.data);
    throw error;
  }
}

export async function removeUserFromCase(caseId, userId, updaterId) {
  try {
    const payload = {
      id: caseId,
      userId,
      updaterId,
    };

    const response = await api.put('UserCaseSaas/RemoveUser', payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    return response.data;
  } catch (error) {
    console.error('updateCase failed:', error);
    console.error('Error details:', error.response?.data);
    throw error;
  }
}

export async function getCreateInfo() {
  try {
    const response = await api.get(
      `${API_BASE_URL}/CasesSaas/Create/Info`,

      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener la lista de causas.';
    throw error;
  }
}

export async function exportCasesExcel(
  search,
  sortBy = null,
  direction = 'desc',
  signal
) {
  try {
    const params = {
      page: 1,
      pageSize: 10000,
      userId: search.UserId,
      searchLegalCases: search.SearchLegalCases || '',
      role: search.Role || '',
      case: search.Case || '',
      client: search.Client || '',
      courts: search.Courts || [],
      sponsorIds: search.Lawyers || [],
      process: search.Process || [],
      stateIds: search.States || [],
      startDate: search.StartDate || null,
      endDate: search.EndDate || null,
      myCases: search.MyCases || 'mis causas',
      businessAreaIds: search.Groups || [],
      sortBy: sortBy || null,
      desc: direction === 'desc',
      internalStateStatus:
        search.IsActive === null || search.IsActive === undefined
          ? undefined
          : search.IsActive
            ? 'Activa'
            : 'Inactiva',
    };

    if (search?.SearchLegalCases?.trim()) {
      params.search = search.SearchLegalCases.trim();
    }

    const response = await api.get('/CasesSaas/ExportExcel', {
      params,
      responseType: 'blob',
      signal,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = `Causas_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error descargando Excel:', error);
    throw error;
  }
}

export async function getCasesByClientId(clientId, signal) {
  try {
    const response = await api.get(`CasesSaas/GetCasesByClient/${clientId}`, {
      signal,
    });
    return response.data || [];
  } catch (error) {
    if (error.response?.status === 404) {
      return [];
    }
    console.error('getCasesByClientId failed:', error);
    console.error('Error details:', error.response?.data);
    error.customMessage = 'No se pudo obtener las causas del cliente.';
    throw error;
  }
}

export async function GetCausasRutBajas(rut) {
  try {
    const response = await api.get(
      `${API_BASE_URL}/General/GetCausasRutBajas`,
      {
        params: { rut: rut },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener la lista de causas.';
    throw error;
  }
}

export async function getCausasRutBajasByClient(clientId) {
  try {
    const response = await api.get(
      `${API_BASE_URL}/General/GetCausasRutBajasByClient`,
      {
        params: { clientId },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener la lista de causas.';
    throw error;
  }
}

export async function updateCausasRutBajas(rut) {
  try {
    const response = await api.put(
      `${API_BASE_URL}/General/UpdateCausasRutBajas`,
      null,
      {
        params: { rut: rut },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener la lista de causas.';
    throw error;
  }
}
